export default {

    "userMenu": {
        "user": "Utilisateur",
        "login": "S'identifier",
        "overrideUser": "Surcharger l'utilisateur",
        "settings": "Paramètres",
        "revertUserOverride": "Revenir à l'utilisateur normal",
        "administration": "Administration",
        "logout": "Se déconnecter",

        "language": "Langue",
        "help": "Aide",
        
        "resetUserSettings": {
            "menu": "Réinitialiser les paramètres utilisateur",
            "modalTitle": "Réinitialiser Paramètres Utilisateur",
            "modalMessage": "Vous êtes sur le point de réinitialiser TOUTES vos données utilisateur (requêtes récentes, collections, alertes, préférences, etc.). Voulez-vous continuer ?",
            "modalConfirmButton": "Confirmer",
            "successMessage": "Réinitialisation des paramètres utilisateur réussie",
            "errorMessage": "Echec de la réinitialisation des paramètres utilisateur"
        },

        "darkMode": "Mode sombre",
        "darkModeOn": "Passer en mode clair",
        "darkModeOff": "Passer en mode sombre",

        "credit": "A propos de Sinequa"
    },

    "editUserSettings": {
        "title": "Paramètres",
        "language": "Langue de l'interface",
        "pageSize": "Nombre de résultats par page",
        "email": "E-mail"
    }

};
